import React, { memo, useMemo } from 'react'
import './FooterSicredi.scss'
import Row from '../row/Row'
import Col from '../col/Col'
import { getMergedClassNames } from '../../utils/HTMLutils'
import QRCodeWhatsapp from '../../assets/icons/QRCodeWhatsapp'
import AnimatedLink from '../animatedLink/AnimatedLink'
const rootClassName = 'footer-sicredi'

interface FooterSicrediProps {
  midiasSociais?: boolean
  theme?: 'white' | 'dark' | 'secondary-lighter'
  maxWidth?: number
}

function FooterSicredi(props: FooterSicrediProps) {
  const colSize: any = [12, 6, 6, 3, 3]
  const qrCodeColor = useMemo(() => {
    switch (props.theme) {
      case 'dark':
        return {
          background: 'transparent',
          color: '#f8f9f7',
          logoBackground: '#3fa110',
          logoColor: '#f8f9f7'
        }
      default:
        return {
          background: 'transparent',
          color: '#33820D'
        }
    }
  }, [props.theme])

  return (
    <footer className={getMergedClassNames([rootClassName, props.theme])}>
      <Row
        className={`${rootClassName}-section`}
        style={{ maxWidth: props.maxWidth ? `${props.maxWidth}px` : 'none' }}
      >
        <Col cols={colSize} className={`${rootClassName}-cell`}>
          <div className={`${rootClassName}-title`}>WhatsApp Corporativo</div>
          <div className={`${rootClassName}-subtitle nunito`}>
            Todas as regiões
          </div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink
              href='https://wa.me/555133584770/?text=Oi%20Sicredi'
              target='_blank'
            >
              51 3358 4770
            </AnimatedLink>
          </div>
          <div className={`${rootClassName}-asterisco nunito`}>
            * Serviço disponível conforme adesão das cooperativas
          </div>
          <div className={`${rootClassName}-space`} />
          <div className={`${rootClassName}-qr-code`}>
            <a
              href='https://wa.me/555133584770/?text=Oi%20Sicredi'
              target='_blank'
              rel='noreferrer'
            >
              <QRCodeWhatsapp {...qrCodeColor} />
            </a>
          </div>
        </Col>
        <Col cols={colSize} className={`${rootClassName}-cell`}>
          <div className={`${rootClassName}-title`}>Serviços por telefone</div>
          <div className={`${rootClassName}-subtitle nunito`}>
            Capitais e regiões metropolitanas
          </div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink href='tel:+555130034770'>3003 4770</AnimatedLink>
          </div>
          <div className={`${rootClassName}-asterisco nunito`}>
            * Custo de uma ligação local
          </div>
          <div className={`${rootClassName}-space`} />
          <div className={`${rootClassName}-title`}>Demais regiões</div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink href='tel:08007244770'>0800 724 4770</AnimatedLink>
          </div>
          <div className={`${rootClassName}-asterisco nunito`}>* Sem custo</div>
        </Col>
        <Col cols={colSize} className={`${rootClassName}-cell`}>
          <div className={`${rootClassName}-title`}>SAC</div>
          <div className={`${rootClassName}-subtitle nunito`}>
            Informações, elogios e reclamações
          </div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink href='tel:08007247220'>0800 724 7220</AnimatedLink>
          </div>
          <div className={`${rootClassName}-space`} />
          <div className={`${rootClassName}-space`} />
          <div className={`${rootClassName}-title`}>Ouvidoria</div>
          <div className={`${rootClassName}-subtitle nunito`}>
            Reclamações e denúncias
          </div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink href='tel:08006462519'>0800 646 2519</AnimatedLink>
          </div>
        </Col>
        <Col cols={colSize} className={`${rootClassName}-cell`}>
          <div className={`${rootClassName}-title`}>
            Chamadas internacionais
          </div>
          <div className={`${rootClassName}-subtitle nunito`}>(a cobrar)</div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink href='tel:+555133784472'>
              +55 51 3378 4472
            </AnimatedLink>
          </div>
          <div className={`${rootClassName}-space`} />
          <div className={`${rootClassName}-space`} />
          <div className={`${rootClassName}-title`}>
            Atendimento aos deficientes
          </div>
          <div className={`${rootClassName}-subtitle nunito`}>
            Auditivos ou de fala
          </div>
          <div className={`${rootClassName}-number`}>
            <AnimatedLink href='tel:08007240525'>0800 724 0525</AnimatedLink>
          </div>
        </Col>
      </Row>
      {props.midiasSociais ? (
        <Row
          className={`${rootClassName}-section`}
          style={{ maxWidth: `${props.maxWidth}px` }}
        >
          <Row>
            <AnimatedLink
              className={`${rootClassName}-social-media nunito`}
              href='https://www.youtube.com/user/sicredioficial'
              target='_blank'
              rel='noreferrer'
            >
              youtube
            </AnimatedLink>
            <AnimatedLink
              className={`${rootClassName}-social-media nunito`}
              href='https://twitter.com/sicredi'
              target='_blank'
              rel='noreferrer'
            >
              twitter
            </AnimatedLink>
            <AnimatedLink
              className={`${rootClassName}-social-media nunito`}
              href='https://www.linkedin.com/company/sicredi'
              target='_blank'
              rel='noreferrer'
            >
              linkedin
            </AnimatedLink>
            <AnimatedLink
              className={`${rootClassName}-social-media nunito`}
              href='https://www.instagram.com/sicredi/'
              target='_blank'
              rel='noreferrer'
            >
              instagram
            </AnimatedLink>
            <AnimatedLink
              className={`${rootClassName}-social-media nunito`}
              href='https://www.facebook.com/Sicredi'
              target='_blank'
              rel='noreferrer'
            >
              facebook
            </AnimatedLink>
          </Row>
          <Row className={`${rootClassName}-endereco`}>
            <Row className='nunito'>
              Confederação das Cooperativas do Sicredi
            </Row>
            <Row className='nunito'>CNPJ: 03.795.072/0001-60</Row>
            <Row className='nunito'>
              Av. Assis Brasil, nº 3940, Jardim Lindoia – Porto Alegre/RS
            </Row>
            <Row className='nunito'>CEP: 91010-003</Row>
          </Row>
        </Row>
      ) : undefined}
    </footer>
  )
}

export default memo(FooterSicredi)
